/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SetupInstrumentsRequestBody } from '../models/SetupInstrumentsRequestBody';
import type { SetupInstrumentsResponse } from '../models/SetupInstrumentsResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class InstrumentsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Start the instruments (proxy and aggregator) for the given `body.mongo_url`.
     * If other endpoints of the instrumentation server are called before this one, they will likely fail as the proxy and aggregator are not running yet.
     * @param requestBody
     * @returns SetupInstrumentsResponse successful operation
     * @throws ApiError
     */
    public setup(
        requestBody: SetupInstrumentsRequestBody,
    ): CancelablePromise<SetupInstrumentsResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/instruments/setup',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
